import styled from "styled-components";

export const Container = styled.div``;

export const SlotDetailCardContainer = styled.div`
    position: relative;
    padding: 10px 35px 35px;
    border: 1px solid #f0f0f0;
    margin-bottom: 30px;
    margin-top: 5px;
    .ant-steps-item-content {
        width: auto;
    }
`;
export const DescriptionTitle = styled.h3`
    margin: 15px 0%;
    font-size: 1.17em !important;
`;
export const ProgressContainer = styled.h3`
    padding-right: 16px;
    margin-top: 20px;
`;
export const ProgressTitle = styled.h5`
    margin-bottom: 0;
`;
